import type { MouseEvent } from "react";

import { cn } from "@/lib/utils";

import type { WireCommand } from "../protocol/protocol";

export const COMMAND_LIST_ID = "agent-command-list";
export const commandOptionId = (index: number) => `${COMMAND_LIST_ID}-${index}`;

const keepFocus = (event: MouseEvent) => event.preventDefault(); // the composer keeps the caret

/**
 * The / list above the composer: each command with its one line. Arrow keys and Enter (in the
 * composer) or a tap send one; Escape closes the list.
 */
export function CommandList({
  items,
  active,
  onPick,
  onActive,
}: {
  items: WireCommand[];
  active: number;
  onPick: (command: WireCommand) => void;
  onActive: (index: number) => void;
}) {
  return (
    <div
      id={COMMAND_LIST_ID}
      role="listbox"
      aria-label="Commands"
      // Phones: full width and flat on the composer's top edge, as the @ list.
      className="absolute bottom-full left-0 z-20 mb-2 max-h-72 w-full overflow-y-auto rounded-lg border bg-popover p-1 text-popover-foreground shadow-md max-sm:mb-0 max-sm:rounded-none max-sm:border-x-0 max-sm:shadow-none sm:w-[26rem]"
      onMouseDown={keepFocus}
    >
      {items.map((command, index) => (
        <div
          key={command.name}
          id={commandOptionId(index)}
          role="option"
          aria-selected={index === active}
          className={cn(
            "flex cursor-pointer items-baseline gap-2 rounded-md px-2 py-1.5 text-sm max-sm:py-2.5",
            index === active && "bg-accent text-accent-foreground"
          )}
          onMouseEnter={() => onActive(index)}
          onClick={() => onPick(command)}
        >
          <span className="shrink-0 font-medium">{command.name}</span>
          <span className="min-w-0 truncate text-xs text-muted-foreground">{command.summary}</span>
        </div>
      ))}
    </div>
  );
}
